import React from 'react';
import { Link } from 'react-router-dom';
import '../../../styles/components/landing/LandingFooter.css';

const LandingFooter = () => {
  const currentYear = new Date().getFullYear();

  const handleContactClick = () => {
    // Handle contact functionality
    console.log('Contact clicked');
  };

  const handleSocialClick = (platform) => {
    // Handle social media links
    console.log(`${platform} clicked`);
  };

  return (
    <footer className="landing-footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="brand-icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <circle cx="16" cy="16" r="14" stroke="#4CAF50" strokeWidth="2"/>
                  <path d="M11 16h10M16 11v10" stroke="#4CAF50" strokeWidth="2"/>
                </svg>
              </div>
              <span className="brand-text">NEUROLEX</span>
            </div>
            <p className="footer-description">
              Empowering mental health through AI-powered solutions. 
              Professional assessment, monitoring, and personalized care.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="link-list">
              <li><Link to="/how-it-works" className="footer-link">How It Works</Link></li>
              <li><Link to="/for-professionals" className="footer-link">For Professionals</Link></li>
              <li><Link to="/for-clinics" className="footer-link">For Clinics</Link></li>
              <li><Link to="/partner-clinics" className="footer-link">Our Partner Clinics</Link></li>
            </ul>
          </div>

          {/* Legal Links */}
          <div className="footer-links">
            <h4 className="footer-title">Legal</h4>
            <ul className="link-list">
              <li><Link to="/privacy" className="footer-link">Privacy Policy</Link></li>
              <li><Link to="/terms" className="footer-link">Terms of Service</Link></li>
              <li><Link to="/contact" className="footer-link">Contact Us</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-contact">
            <h4 className="footer-title">Get in Touch</h4>
            <div className="contact-info">
              <div className="contact-item">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M2.667 2.667h10.666c.734 0 1.334.6 1.334 1.333v8c0 .733-.6 1.333-1.334 1.333H2.667c-.734 0-1.334-.6-1.334-1.333V4c0-.733.6-1.333 1.334-1.333z" stroke="currentColor" strokeWidth="1.333" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M14.667 4L8 8.667 1.333 4" stroke="currentColor" strokeWidth="1.333" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>support@neurolex.com</span>
              </div>
              <div className="contact-item">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M14.667 11.28v1.387a.933.933 0 01-1.02.933c-1.386-.06-2.72-.48-3.886-1.226a9.61 9.61 0 01-2.708-2.708c-.747-1.167-1.167-2.5-1.227-3.887a.933.933 0 01.933-1.02h1.387a.933.933 0 01.933.8c.06.453.171.898.333 1.327a.933.933 0 01-.21.986l-.587.587a7.467 7.467 0 002.708 2.708l.587-.587a.933.933 0 01.986-.21c.429.162.874.273 1.327.333a.933.933 0 01.8.933v0z" stroke="currentColor" strokeWidth="1.333" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>+1 (555) 123-4567</span>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>&copy; {currentYear} NEUROLEX. All rights reserved.</p>
          </div>
          <div className="footer-meta">
            <span>Made with ❤️ for better mental health</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;